import axios from "axios";

let baseURL = `${process.env.REACT_APP_BACKEND_URL || "https://myindustrialdata-backend.pritech.com.pe"}/api/`
let refresh = false;

const axiosInstance = axios.create({
    baseURL: baseURL
});

// Event target for global 402 error handling
export const limitErrorEmitter = new EventTarget();

axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
axiosInstance.interceptors.response.use(resp => resp, async error => {
    // Si no hay respuesta del servidor (error de red), rechazar la promesa
    if (!error.response) {
        return Promise.reject(error);
    }

    if (error.response.status === 401 && !refresh) {
        refresh = true;
        axiosInstance.post('token/refresh/', {
            refresh:localStorage.getItem('refresh_token')
        }).then((response) => {
            axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${response.data['access']}`;
            localStorage.setItem('access_token', response.data.access);
            window.location.reload();
        }).catch((err) => {
            localStorage.clear();
            axiosInstance.defaults.headers.common['Authorization'] = null;
            window.location.href = '/login';
        });
    }

    // Global 402 handler - emit event for LimitErrorProvider
    if (error.response.status === 402) {
        const data = error.response.data || {};
        limitErrorEmitter.dispatchEvent(new CustomEvent('limit-error', {
            detail: {
                error: data.error || 'Limit reached',
                code: data.code || '',
                current: data.current || 0,
                max: data.max || 0,
                subscriptionStatus: data.status || data.subscription_status || ''
            }
        }));
    }

    refresh = false;
    return Promise.reject(error);
});

export default axiosInstance;
